import { useContext, useEffect } from 'react';
import Dashboard from './Dashboard';
import AddReport from './AddReport';
import Core from '../core/Core';
import { ReportContext } from '../Context';

function Edition() {
  const { report, pickReport } = useContext(ReportContext);
  console.log('Valeur actuelle de report dans Edition.js :', report);
  
  // Effet pour rediriger vers Dashboard si aucun rapport n'est sélectionné au chargement initial
  useEffect(() => {
    if (report === null) {
      // Cette ligne ne forcera pas un re-rendu en boucle car pickReport ne change pas report
      // si report est déjà null, donc l'effet ne s'exécutera qu'une fois
      pickReport(null);
    }
  }, []);

  if (report === 'new' || (report && report.new)) {
    return (
      <div>
        <AddReport
          prefilledNumber={report?.number || ''}
          prefilledYear={report?.year || ''}
        />
      </div>
    );
  } else if (report) {
    return (
      <div>
        <Core />
      </div>
    );
  } else {
    // Le cas par défaut (report === null) affiche toujours Dashboard
    return (
      <div>
        <Dashboard />
      </div>
    );
  }
}

export default Edition;